function AddWishlistCarrello(IDDS, LoginService) {
    var cdc = $('#listcdc-wishlist').dxList('instance').option('selectedItem');

    if (mainController.VerificaDisponibilitaProdotto('' + IDDS) == true) {
        if (LoginService.toLowerCase() == "account") {
            checkoutController.AccountAddCart(IDDS, 1, cdc?.Key, 'wishlist');
            const popup = $('#Wishlist_Popup').dxPopup('instance'); popup.hide();
        }
        else {
            checkoutController.AddCart(IDDS, 1, cdc?.Key, 'wishlist');
            const popup = $('#Wishlist_Popup').dxPopup('instance'); popup.hide();
        }
    }
}

// Parametro cdcObbligatorio: booleano che indica se il centro di costo e' obbligatorio (Claude)
function AddBulkWishlistCarrello(cdcObbligatorio) {
    var EsisteCdc = $('#listcdc-wishlist');
    if (EsisteCdc.length > 0) {
        var cdc = EsisteCdc.dxList('instance').option('selectedItem');
    }
    var errore = false;
    const popup = $('#Wishlist_Popup').dxPopup('instance');

    var selected = GetSelectedCards();
    if (selected.length > 0) {
        if (!cdcObbligatorio || (cdcObbligatorio && cdc && cdc.Key > 0)) {
            errore = checkoutController.AddCartBulk(selected, 1, cdc ? cdc.Key : 0, 'wishlist');
        }
        else {
            mainController.NotifyMessageTimed(mainController.GetLabel('lNecessarioCentroDiCosto'), Costanti.NOTIFY_COLOR_ERROR, 3000);
            popup.hide()
            errore = true;
        }

        if (!errore) {
            popup.hide();
            setTimeout(function () {
                window.location.href = '/Checkout/Carrello';
            }, 3000);
        }
    }
    else {
        mainController.NotifyMessageTimed("Selezione almeno un prodotto", Costanti.NOTIFY_COLOR_DANGER, 3000);
        popup.hide()
    }

}